module.exports = __webpack_public_path__ + "img/carve_step1.48268392.png";